import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { CustomerContext } from '../../contexts/CustomerContext'
import Typography from '../Typography'
import cameraPng from '../../assets/nav/camera.png'
import Image from '../Image/Image'
import routes from '../../routes'
import { getOptionName, isDaylightSavingTime, isDSTObserved, studentFullName } from '../../utils/functions'
import { DAYS, MONTHS } from '../../utils/variables'
import classes from './appointment-item.module.sass'
import Cart from '../../models/Cart'

const AppointmentItem = ({ orderPackage }) => {
  const history = useHistory()
  const { customer, setCustomer } = useContext(CustomerContext)
  const [isDeleted, setIsDeleted] = useState(false)
  const optionName = getOptionName(orderPackage.apiOption.name)
  let [dateVal, timeVal] = orderPackage.appointmentTime.split(' ')

  timeVal = timeVal.split(':')

  if (!isDaylightSavingTime()) {
    timeVal[0] = (parseInt(timeVal[0], 10) + 8).toString()
  } else {
    timeVal[0] = (parseInt(timeVal[0], 10) + 7).toString()
  }

  timeVal = timeVal.join(':')

  const dateString = `${dateVal}T${timeVal}+00:00`

  const date = new Date(Date.parse(dateString))

  const editAppointment = () => {
    setCustomer({ ...customer, currentOrderPackage: orderPackage })
    history.push(routes.appointmentOptionSelection(orderPackage.packageId))
  }

  const deleteAppointment = () => {
    orderPackage
      .destroy()
      .then(() => {
        Cart
          .includes([{ orderPackages: [{ student: ['school'] }, 'apiOption'] }])
          .where({ for_email: [customer.apptCart.id, customer.email] })
          .first()
          .then((res) => {
            setCustomer({ ...customer, apptCart: res.data })
            setIsDeleted(true)
          })
      })
  }

  if (isDeleted) return null

  return (
    <span className={classes.item}>
      <div className={classes.top}>
        <div className={classes.studentInfo}>
          <Typography>{studentFullName(orderPackage.student, true)}</Typography>
          <Typography classes={classes.grade}>
            Grade:
            {' '}
            {orderPackage.student.grade}
          </Typography>
        </div>
        <Typography>
          School:
          {' '}
          {orderPackage.student.school.name}
        </Typography>
      </div>
      <div className={classes.middle}>
        <Image src={cameraPng} alt="camera" />
        <div>
          <Typography classes={classes.optionName} weight="bold">
            {optionName[0]}
            {' '}
            {optionName[1]}
          </Typography>
          <Typography classes={classes.appointmentOnly}>
            By Appointment Only
          </Typography>
          <Typography classes={classes.appt} weight="bold">
            {DAYS[date.getDay()]}
            {', '}
            {MONTHS[date.getMonth()]}
            {' '}
            {date.getDate()}
          </Typography>
          <Typography classes={classes.appt} weight="bold">
            Time:
            {' '}
            {date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true })}
          </Typography>
        </div>
      </div>
      <div className={classes.bottom}>
        <div onClick={editAppointment}>
          <Typography>Edit</Typography>
        </div>
        <div onClick={deleteAppointment}>
          <Typography>Delete</Typography>
        </div>
      </div>
    </span>
  )
}

AppointmentItem.propTypes = {
  orderPackage: PropTypes.object.isRequired,
}

export default AppointmentItem
